import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { hotjar } from 'react-hotjar'
import { MuiThemeProvider, createTheme, StylesProvider } from '@material-ui/core/styles'
import useAutoRefreshTimer from 'hooks/useAutoRefreshTimer'

import ToastHandler from './ToastHandler'
import LightboxHandler from './LightboxHandler'
import {
  PageNotFound,
  Home,
  Dashboard,
  SystemMessageLiveReport,
  LiveReport,
  Unsubscribe
} from './pages/index'
import useIframeMessageHandler from './hooks/useIframeMessageHandler'

function App() {
  useIframeMessageHandler()
  useAutoRefreshTimer()

  const muiTheme = createTheme({
    typography: {
      fontFamily: [
        'IBM Plex Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'sans-serif'
      ].join(',')
    }
  })
  hotjar.initialize(2765197, 6)

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={muiTheme}>
        <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="home" element={<Home />} />
            <Route exact path="dashboard/*" element={<Dashboard />} />
            <Route exact path="404" element={<PageNotFound />} />
            <Route exact path="system-message-live-report" element={<SystemMessageLiveReport />} />
            <Route exact path="/live-report/:reportId" element={<LiveReport />} />
            <Route exact path="/unsubscribe/:subscriptionUuid" element={<Unsubscribe />} />
            {/* <Route path="*" element={<PageNotFound />} /> */}
          </Routes>
          <ToastHandler />
          <LightboxHandler />
        </BrowserRouter>
      </MuiThemeProvider>
    </StylesProvider>
  )
}

export default App
